import * as React from 'react';

interface ListItem {
  readonly id?: string;
  readonly title: string;
}

export interface ItemListProps<T extends ListItem> {
  items: ReadonlyArray<T>;
  onClick: (item: T, index: number) => void;
  onClickDelete?: (item: T, index: number) => void;
  createListRowItem?: (item: T) => JSX.Element;
  itemStyle?: Readonly<React.CSSProperties>;
  containerStyle?: Readonly<React.CSSProperties>;
}

export class ItemList<T extends ListItem> extends React.PureComponent<ItemListProps<T>, {}> {
  public static defaultProps = {
    itemStyle: {
      textDecoration: 'underline',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      borderBottom: '1px solid #aaa',
    },
    containerStyle: {
      width: '500px',
      height: '300px',
      overflow: 'auto',
    },
  };

  private handleClick = (item: T, index: number) => {
    this.props.onClick(item, index);
  }

  private createList = (): ReadonlyArray<JSX.Element> => {
    return this.props.items.map(this.createListRow);
  }

  private handleDeleteClick = (item: T, index: number) => {
    if (this.props.onClickDelete) {
      this.props.onClickDelete(item, index);
    }
  }

  private createDeleteButtonIfNeeded = (
    item: T, index: number,
  ): JSX.Element | null => {
    return this.props.onClickDelete !== undefined
      ? <a onClick={() => this.handleDeleteClick(item, index)}>削除</a>
      : null;
  }

  private createListRow = (item: T, index: number): JSX.Element => {
    return <div style={this.props.itemStyle} key={index}>
      <span style={{ flex: 1 }} onClick={() => this.handleClick(item, index)}>
        {this.props.createListRowItem !== undefined
          ? this.props.createListRowItem(item)
          : <span>{item.title}</span>}
      </span>
      {this.createDeleteButtonIfNeeded(item, index)}
    </div>;
  }

  public render() {
    return (
      <div style={this.props.containerStyle}>
        {this.createList()}
      </div>
    );
  }
}
